var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intelligentsystem-layout"},[(_vm.showNav)?_c('headers',{attrs:{"data-aos":"slide-down","data-aos-delay":"0"}}):_vm._e(),_c('div',{staticStyle:{"flex":"1","overflow-y":"auto"}},[_c('router-view')],1),_c('navMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }